import { getLocale } from './i18n';
import nl from '../i18n/nl.json';
import fr from '../i18n/fr.json';

const locales: Record<string, Record<string, unknown>> = { nl, fr };

export function tLocal(key: string, ...vars: (string | number)[]): string {
	const locale = getLocale();
	const translations = locales[locale] ?? locales.nl;
	let result: string =
    (key.split('.').reduce((obj: unknown, k: string) =>
      obj !== null && obj !== undefined && typeof obj === 'object' ? (obj as Record<string, unknown>)[k] : undefined,
    translations) as string | undefined) ?? key;
	vars.forEach((v, i) => {
		result = result.replace(new RegExp(`\\{${i + 1}\\}`, 'g'), String(v));
	});
	return result;
}
